import { observer } from 'mobx-react-lite'
import useInitialMount from 'reusable/hooks/useInitialMount'
import useStore from 'reusable/mobx-store-utils'
import XeroXpmConectStore, { XeroOriginType } from './XeroXpmConnectStore'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import AdvisorIntegrationCard from 'features/org/edit/integrations/AdvisorIntegrationCard'
import { useXpmConnectionStore } from './XpmConnectionStore'

interface IXeroXpmConnnectProps {
   origin?: XeroOriginType
   /**
    * When true and the integration is connected, shows a "Sync now" button in place of
    * the chip + hover-disconnect affordance.
    */
   showSyncAction?: boolean
}

export default observer(function XeroXpmConnect(props: IXeroXpmConnnectProps) {
   const orgGuardStore = useOrgGuardStore()
   const xpmConnectionStore = useXpmConnectionStore()
   const xeroXpmConectStore = useStore(sp => new XeroXpmConectStore(sp), { originType: props.origin || 'app', orgGuardStore, xpmConnectionStore })

   useInitialMount(() => {
      xeroXpmConectStore.initialiseSettings()
   })

   const connectedAction = props.showSyncAction && xeroXpmConectStore.integrationCardStatus === 'connected'
      ? { label: 'Sync now', onClick: xeroXpmConectStore.syncNow, loading: xeroXpmConectStore.isSyncing }
      : undefined

   return <AdvisorIntegrationCard
      title="Xero Practice Manager"
      subTitle={`Sync clients from ${xeroXpmConectStore.xpmName || 'XPM'}`}
      loading={xeroXpmConectStore.busy}
      status={xeroXpmConectStore.integrationCardStatus}
      onClick={xeroXpmConectStore.integrationCardStatus === 'not connected' ? xeroXpmConectStore.connect : xeroXpmConectStore.disconnect}
      icon={<img src="/images/icons/xero-logo.svg" width="35" />}
      connectedAction={connectedAction}
   />
})
